module.exports = __webpack_public_path__ + "img/portfolio-10-480x343.1ae6192b.jpg";